export default "__VITE_ASSET__nXyohmb___"